// extracted by mini-css-extract-plugin
module.exports = {"controls":"reportModal_controls__Hfv54"};